import { env } from "~/env.mjs";

import { Location } from "~/components/v3/shadcn/LocationSelector";
import { generateTimezoneList } from "~/components/v3/shadcn/Timezone";

const zones = generateTimezoneList();

export const getTimezoneFromLocation = async (
    location: Location,
    startTime: Date,
) => {
    if (location.utcOffset) {
        const hours = Math.abs(Math.floor(location.utcOffset / 60));
        const sign = location.utcOffset >= 0 ? "+" : "-";
        const formattedOffset = `${sign}${hours.toString().padStart(2, "0")}:00`;

        const matchingTimezone = zones.find(
            (zone) =>
                zone.offset === formattedOffset && zone.city === location.city,
        );

        if (matchingTimezone) {
            return matchingTimezone.value;
        }
    }

    if (location.latitude && location.longitude) {
        try {
            const u = new URLSearchParams({
                location: `${location.latitude},${location.longitude}`,
                timestamp: Math.floor(startTime.getTime() / 1000).toString(),
                key: env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
            }).toString();

            const apiUrl = `https://maps.googleapis.com/maps/api/timezone/json?${u}`;
            const response = await fetch(apiUrl);

            if (response.ok) {
                const data = await response.json();
                if (data.status !== "OK") return;

                const matchingTimezone = zones.find(
                    (zone) => zone.value === data.timeZoneId,
                );

                if (matchingTimezone) {
                    return matchingTimezone.value;
                }
            }
        } catch (error) {
            console.error("Error fetching timezone:", error);
        }
    }
};
